import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { createVariation } from "../projectVariations";
import { queryKeys } from "../queryKeys";
import { payloadType } from "src/types/InspectionPayloadType";
import useMyUser from "./useMyUser";
import useFileMutation from "./useFileMutation";
import { useEffect } from "react";

export default function useCreateVariation() {
  const { companyId, deviationId, inspectionId } = useParams();
  const queryClient = useQueryClient();
  const { create: createFile } = useFileMutation();
  useEffect(() => {
    if (createFile.status === "success") {
      queryClient.invalidateQueries({
        queryKey: queryKeys.files(
          Number(companyId),
          Number(createFile.variables?.deviationId)
        ),
      });
    }
  }, [createFile.status, companyId]);
  const mutation = useMutation({
    mutationFn: async (payload: payloadType) => {
      const data = { ...payload, title: payload.title || "-" };
      if (data.files) {
        delete data.files;
      }

      const result = await createVariation(data);
      if (result.data.id) {
        payload.files?.forEach((file) => {
          file.deviationId = result.data.id;
          file.companyId = Number(companyId);
          createFile.mutate(file);
        });
      }
      return result.data;
    },
    mutationKey: [
      queryKeys.variations(companyId),
      "Create",
      Number(deviationId || inspectionId),
    ],
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.variations(companyId),
      });
    },
  });

  return mutation;
}
